export const colorMapping = (val: string) => {
  switch (val) {
    case 'amber':
      return '#FF9500';
    case 'red':
      return '#F04438';
    case 'green':
      return '#51A51A';
    default:
      return '#51A51A';
  }
};

export const airportGetColor = (color: string) => {
  switch (color) {
    case 'black':
      return '#000';
    case 'yellow':
      return '#FC0';
    case 'green':
      return '#1DB954';
    case 'red':
      return '#F04438';
    case 'blue':
      return '#007AFF';
    case 'amber':
      return '#FF9500';
    default:
      return '#F1F1F1';
  }
};

export const runwayFavourabilityColor = (color: string) => {
  if (color === 'N/A' || !color) return '#f1f1f1';
  if (color === 'Less favourable') return '#FF9500';
  if (color === 'Unfavourable') return '#E94860';
  return '#51A51A';
};

export const runwayColor = (color: string) => {
  switch (color) {
    case 'green':
      return '#51A51A';
    case 'red':
      return '#E94860';
    case 'amber':
      return '#FF9500';
    default:
      return '#F1F1F1';
  }
};

export const redWords: string[] = [
  'TEMPO',
  'RA',
  'SHRA',
  'RESHRA',
  '-SHRA',
  '+SHRA',
  'TS',
  'TSRA',
  '-TSRA',
  '+TSRA',
  'RETS'
];
